import { motion } from "framer-motion";
import { WHY_US } from "@/data/site";

export default function WhyChooseUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative overflow-hidden bg-[#0A192F] text-white rs-section rs-grain"
    >
      <div className="absolute inset-0 -z-0 opacity-40">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-[#F97316]/15 blur-[120px]" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-[#F97316]/10 blur-[120px]" />
      </div>

      <div className="rs-container relative z-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <p className="rs-overline mb-4">Why Choose Us</p>
            <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl leading-tight">
              Reliable pros. Real results.{" "}
              <span className="text-[#F97316]">Zero drama.</span>
            </h2>
            <p className="mt-6 text-white/70 text-base md:text-lg leading-relaxed">
              We built RS Handyman Services on the values we look for in every trades pro:
              honest, on time, and skilled. It&apos;s why our customers keep coming back.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {WHY_US.map((item, idx) => {
              const Icon = item.icon;
              return (
                <motion.div
                  key={item.title}
                  data-testid={`why-item-${idx}`}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.45, delay: (idx % 4) * 0.06 }}
                  className="group rounded-2xl p-6 bg-white/[0.04] border border-white/10 hover:bg-white/[0.08] hover:border-[#F97316]/40 transition-all"
                >
                  <div className="h-11 w-11 rounded-xl bg-[#F97316]/15 grid place-items-center">
                    <Icon strokeWidth={1.6} className="h-5 w-5 text-[#F97316]" />
                  </div>
                  <h3 className="mt-5 font-display font-semibold text-lg">{item.title}</h3>
                  <p className="mt-1.5 text-sm text-white/60 leading-relaxed">{item.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
